import React from 'react'

import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from 'material-ui/Dialog'

import styles from 'styles/components/PatchNotes'

class PatchNotes extends React.Component {
  render() {
    const { classes, onClose, version, updates, fixes, notes } = this.props
    return (
      <Dialog onClose={onClose} open>
        <DialogTitle>Patch Notes</DialogTitle>
        <DialogContent>
          <div className={classes.textBlock}>
            <Typography variant="subheading">Version</Typography>
            {version}
          </div>
          <div className={classes.textBlock}>
            <Typography variant="subheading">Notes</Typography>
            {notes}
          </div>
          <div className={classes.textBlock}>
            <Typography variant="subheading">What's New?</Typography>
            <ul className={classes.textList}>
              {updates.map((update, index) => <li key={index}>{update}</li>)}
            </ul>
          </div>
          <div className={classes.textBlock}>
            <Typography variant="subheading">Fixes</Typography>
            <ul className={classes.textList}>
              {fixes.map((fix, index) => <li key={index}>{fix}</li>)}
            </ul>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" autoFocus>
            Sweet!
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

PatchNotes.defaultProps = {
  notes: 'Regular patch notes',
  updates: ['None'],
  fixes: ['None']
}

export default withStyles(styles)(PatchNotes)



// WEBPACK FOOTER //
// ./src/components/Dialogs/PatchNotes.jsx